module.exports = __webpack_public_path__ + "img/14.ce311527.png";